import { render, staticRenderFns } from "./ViewTechnical.vue?vue&type=template&id=16a31800&scoped=true&"
import script from "./ViewTechnical.vue?vue&type=script&lang=js&"
export * from "./ViewTechnical.vue?vue&type=script&lang=js&"
import style0 from "./ViewTechnical.vue?vue&type=style&index=0&id=16a31800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a31800",
  null
  
)

export default component.exports